'use client'

import TabBarProfile from '@/features/profile-page/TabBarProfile'
import { redirect } from 'next/navigation'
import React from 'react'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import { Helmet } from 'react-helmet'

export const ProfilePage = () => {
    const navigate = (path) => redirect(path)
    const { userAuth: isAuth } = useGetIsAuthUser()

    React.useEffect(() => {
        console.log(isAuth)
        if (!isAuth) {
            navigate('/login')
        }
    }, [isAuth])

    return (
        <div className={'ProfilePage'}>
            <Helmet>
                <title>Профиль</title>
            </Helmet>
            <h1>Управление аккаунтом</h1>
            <TabBarProfile />
        </div>
    )
}
